import { EDA } from "motw_core/Dreams/EDreamAttribute";
import * as React from "react";
import { Dreams } from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { GetExclusionLinkStyleClass } from "./ExclusionLinks";

export function ExcludeAttributesLink({
    dreams,
    attribute,
}: {
    dreams: Dreams;
    attribute: EDA;
}) {
    const isActive = dreams.state.excludedAttributes.includes(EDA[attribute]);
    const icon = isActive ? EGlyphicon["eye-open"] : EGlyphicon["eye-close"];

    return (
        <IconWithText
            iconSuffix={icon}
            whenClicked={() => {
                Toggle(dreams, attribute, isActive);
            }}
            displayAsBlock={false}
            withClass={GetExclusionLinkStyleClass(isActive)}
        >
            {`${EDA[attribute]}s`}
        </IconWithText>
    );
}

function Toggle(dreams: Dreams, attribute: EDA, isActive: boolean) {
    const newExcludedAttributes = isActive
        ? ArrayUtils.Exclude(dreams.state.excludedAttributes, EDA[attribute])
        : [...dreams.state.excludedAttributes, EDA[attribute]];

    dreams.setState({
        excludedAttributes: newExcludedAttributes,
    });
}
